<template>
  <div>
    <!-- <v-btn  :disabled="btnApoderadosDisabled" @click="migrarApoderados">Migrar Apoderados</v-btn> -->
    <v-btn :disabled="btnSociosDisabled" @click="migrarSocios">Migrar Socios</v-btn>
    <v-btn :disabled="btnHerederosDisabled" @click="migrarHerederos">Migrar Herederos</v-btn>
    <v-btn :disabled="btnLiquidarONIDisabled" @click="liquidarONI">Liquidar ONI</v-btn>
    <!-- <v-btn @click="migracionGestion">TEST MIGRACION PAGO</v-btn> -->
    <MigracionPagoGestion />
    <v-btn @click.once="$router.push({ path: `/` })">Volver</v-btn>
    {{ errorMessage }}
    {{ message }}
  </div>
</template>

<script>

import MigracionPagoGestion from '@/components/pago/MigracionPagoGestion';
import axios from "axios";
export default {
  components: {
    MigracionPagoGestion
  },
  data() {
    return {
        errorMessage: "",
        message: "",
        loading: false,
        btnApoderadosDisabled: false,
        btnSociosDisabled: false,
        btnHerederosDisabled: false,
        btnLiquidarONIDisabled: false
    };
  },
  methods: {
      // migrarApoderados() {
      //     axios.get('/sgs/migracion/apoderados')
      //       .then(res => {
      //           this.btnApoderadosDisabled = true;
      //           this.message = "Migracion iniciada!"
      //           console.log(res)
      //   })
      //   .catch(err => {
      //     this.message = ""
      //     this.loading = false;
      //     console.log(err);
      //     if (err.response.data) {
      //       this.errorMessage = err.response.data;
      //     } else {
      //       this.errorMessage = "Error";
      //     }
      //   });
      // },
      migrarSocios() {
          axios.get('/sgs/migracion/socios')
            .then(res => {
                this.btnSociosDisabled = true;
                this.message = "Migracion iniciada!"
                console.log(res)
        })
        .catch(err => {
          this.message = ""
          this.loading = false;
          console.log(err);
          if (err.response.data) {
            this.errorMessage = err.response.data;
          } else {
            this.errorMessage = "Error";
          }
        });
      },
      migrarHerederos() {
          axios.get('/sgs/migracion/herederos')
            .then(res => {
                this.btnHerederosDisabled = true;
                this.message = "Migracion iniciada!"
                console.log(res)
        })
        .catch(err => {
          this.message = ""
          this.loading = false;
          console.log(err);
          if (err.response.data) {
            this.errorMessage = err.response.data;
          } else {
            this.errorMessage = "Error";
          }
        });
      },
      liquidarONI() {
          this.btnLiquidarONIDisabled = true;
          axios.post('/liquidacion/liquidarONI')
            .then(res => {
                this.message = "Liquidacion finalizada!"
                console.log(res)
        })
        .catch(err => {
          this.message = ""
          this.loading = false;
          console.log(err);
          if (err.response.data) {
            this.errorMessage = err.response.data;
          } else {
            this.errorMessage = "Error";
          }
        });
      },
  }
};
</script>
